import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/orcas-logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-58801da2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sidebar-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "orcas logo"
}, null, -1 /* HOISTED */))
const _hoisted_3 = { class: "sidebar-list" }

import { computed, onUnmounted, shallowRef, watch } from 'vue'
import { getVisibleMenuItems, MenuLeaf } from '@sennder/shell-utilities'

import AppLayoutSidebarEntry from './AppLayoutSidebarEntry.vue'
import { ANALYTICS_EVENTS } from '@/services/analyticsEvents'
import { getStateData } from '@/store/getters'
import { analytics } from '@/services/analyticsProvider'
import { AppNavigation, navigation } from '@/config/navigation'
import { AppRoute, routes } from '@/config/routes'
import { getAppSidebarState } from './AppSidebarIconState'
import { mapLegacyIcon } from './legacy-icon'
import { featureFlag } from '@/services/featureFlagProvider'

interface ISidebarLink {
  icon: string
  translationKey: string
  route: AppRoute
  analyticsEvent: string
  isNewFeature: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppLayoutSidebar',
  emits: ['click'],
  setup(__props, { emit: emits }) {



const navigationItems = shallowRef<AppNavigation[]>([])

// TODO: Revisit it after we migrate to the new provider fully. Most likely we don't need to re-evaluate guards on the flag change. Right now, this functionality is overcomplicated and duplicated in multiple places.
const stopWatchLegacyFlags = featureFlag.devFunctions.watchAllFlags(() => {
  navigationItems.value = getVisibleMenuItems(navigation)
})

watch(
  [() => getStateData()],
  () => {
    navigationItems.value = getVisibleMenuItems(navigation)
  },
  {
    deep: true,
    immediate: true,
  }
)

const appSidebarState = getAppSidebarState()

const sidebarItems = computed<ISidebarLink[]>(() =>
  navigationItems.value.map((item) => {
    // TODO: types will fix after migration to new sidebar
    const leaf = item as MenuLeaf<AppRoute>
    const route = routes[leaf.route]
    return {
      icon: mapLegacyIcon(leaf.route),
      route: leaf.route,
      translationKey: item.translationKey,
      // TODO: extend Navigation<> to include isNewFeature
      isNewFeature:
        (leaf.route === '/sennfuel' || leaf.route === '/marketplace/tenders') &&
        appSidebarState[route.name] &&
        appSidebarState[route.name] === 'unvisited',
      // TODO: extend Navigation<> to include analyticsEvent
      analyticsEvent: `MENU_${route.name.toUpperCase()}_CLICK`,
    }
  })
)

const onClickItem = (analyticsEvent: string) => {
  analytics.trackEvent(
    ANALYTICS_EVENTS[analyticsEvent as keyof typeof ANALYTICS_EVENTS]
  )
  emits('click')
}

onUnmounted(() => {
  stopWatchLegacyFlags()
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      class: "sidebar-logo",
      to: sidebarItems.value[0].route,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(analytics).trackEvent(_unref(ANALYTICS_EVENTS).MENU_ICON_CLICK)))
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["to"]),
    _createElementVNode("nav", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sidebarItems.value, (item, idx) => {
        return (_openBlock(), _createBlock(AppLayoutSidebarEntry, {
          key: `item-${idx}`,
          class: "sidebar-item",
          route: item.route,
          "translation-key": item.translationKey,
          "is-new": item.isNewFeature,
          icon: item.icon,
          onClick: ($event: any) => (onClickItem(item.analyticsEvent))
        }, null, 8 /* PROPS */, ["route", "translation-key", "is-new", "icon", "onClick"]))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ]))
}
}

})